"use memo"

import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client'
import { TaskModalPageProps } from '../TaskModalPageProps'
import QldAgreementComplianceTypePage from './QldAgreementComplianceTypePage'
import NswAgreementComplianceTypePage from './NswAgreementComplianceTypePage'

const AgreementComplianceTypePage = (props: TaskModalPageProps) => {
  switch (props.campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementComplianceTypePage {...props} />
    case CampaignDetailModelState.NSW:
      return <NswAgreementComplianceTypePage {...props} />
    default:
      return null
  }
}

export default AgreementComplianceTypePage
